import Vue from 'vue'
import App from './App.vue'

import Vuex from 'vuex'
import store from '@/store/index'
Vue.use(Vuex)

import VueCompositionAPI from '@vue/composition-api'
Vue.use(VueCompositionAPI)

import cornerstonePlugin from '@/plugins/cornerstonePlugin'
Vue.use(cornerstonePlugin)

import cornerstoneToolsPlugin from '@/plugins/cornerstoneToolsPlugin'
Vue.use(cornerstoneToolsPlugin)

import dialogPdftoImagePlugin from '@/plugins/dialogPdftoImagePlugin'
Vue.use(dialogPdftoImagePlugin)

import JsonViewer from 'vue-json-viewer'
Vue.use(JsonViewer)

import './quasar'

Vue.config.productionTip = false

new Vue({
  store: store.store,
  render: h => h(App),
}).$mount('#app')

import dotenv from 'dotenv';
dotenv.config();